import * as yup from 'yup';
const isRecoverableError = (value) => {
    return (value.recoverableError !== undefined);
};
/**
 *
 * @param apiValidationResultCheck the check that defines when an api result is valid
 * @param recoverableErrors an array of recoverable errors
 * @returns yup schema with pre-defined messages for an api response not passing the given check, an api error or each recoverable errors
 */
function createApiFieldValidationSchema(apiValidationResultCheck, recoverableErrors) {
    return yup
        .mixed()
        .nullable()
        .required('apiValidationRequired')
        .test('apiValidationRequired', 'apiValidationRequired', (value) => value !== 'REQUIRED')
        .test('apiValidationApiError', 'apiValidationApiError', (value) => value !== 'APIERROR')
        .test('preApiValidationError', 'preApiValidationError', (value) => value !== 'PREAPIVALIDATIONERROR')
        .test('apiValidationRecoverableError', (value) => isRecoverableError(value.value)
        ? `apiValidationRecoverableError.${value.value.recoverableError}`
        : 'apiValidationRecoverableError', (value) => {
        return isRecoverableError(value)
            ? !recoverableErrors?.includes(value.recoverableError)
            : true;
    })
        .test('apiValidationResult', 'apiValidationResult', (value) => value !== 'APIERROR' &&
        value !== 'REQUIRED' &&
        value !== 'PREAPIVALIDATIONERROR' &&
        !isRecoverableError(value) &&
        apiValidationResultCheck(value));
}
export const apiFieldValidationSchemaUtils = {
    createApiFieldValidationSchema,
};
